export default __webpack_public_path__ + "static/media/IntegrationFacebok.91b00a8c.jpg";